module.exports = __webpack_public_path__ + "static/media/logo192.b2256095.png";